module.exports = __webpack_public_path__ + "img/E30-4.f62b2ddd.png";